module.exports = __webpack_public_path__ + "static/media/back_arrow.38af8acc.svg";